export const formatDate = (date: number) => new Date(date * 1000).toISOString();

export const formatDateString = (date: number) => new Date(date * 1000).toDateString();
